/**
 * What a page has open, for feedback reports: the job, the capture, the
 * contact... Each view that opens something says so with usePageIds(layer,
 * ids); the report reads the union. Only the keys below, and only plain ids
 * (no names, no free text), so nothing personal rides along by accident.
 * Nothing is guessed: a view that does not call usePageIds adds nothing.
 */
import { useEffect } from "react";

export const PAGE_ID_KEYS = [
  "jobId", "quoteId", "contactId", "clientId", "segmentId", "campaignId",
  "rosterEntryId", "subjectId", "projectId", "captureSn", "sessionId", "plannerSessionId",
  "view", "door", "mode",
];
const ID_RE = /^[A-Za-z0-9_.:-]{1,128}$/;

const layers = new Map();

export function cleanIds(ids) {
  const out = {};
  if (!ids || typeof ids !== "object") return out;
  for (const k of PAGE_ID_KEYS) {
    const v = ids[k];
    if (typeof v === "string" && ID_RE.test(v)) out[k] = v;
  }
  return out;
}

export function setPageIds(layer, ids) {
  layers.set(layer, cleanIds(ids));
}

export function clearPageIds(layer) {
  layers.delete(layer);
}

/** Every layer's ids merged (later layers win on the same key). */
export function currentPageIds() {
  const out = {};
  for (const ids of layers.values()) Object.assign(out, ids);
  return out;
}

/**
 * Publish this view's open ids while it is mounted. `ids` values that are
 * null/undefined are left out. Cheap: a Map write per change.
 */
export function usePageIds(layer, ids) {
  const key = JSON.stringify(cleanIds(ids));
  useEffect(() => {
    layers.set(layer, JSON.parse(key));
    return () => { layers.delete(layer); };
  }, [layer, key]);
}
